import { render, staticRenderFns } from "./LabelRegion.vue?vue&type=template&id=56365e43&scoped=true&"
import script from "./LabelRegion.vue?vue&type=script&lang=js&"
export * from "./LabelRegion.vue?vue&type=script&lang=js&"
import style0 from "./LabelRegion.vue?vue&type=style&index=0&id=56365e43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56365e43",
  null
  
)

export default component.exports